import styled from 'styled-components';

const LoadingWrapper = styled.div`
  display: flex;
  height: 100vh;
  grid-column-start: 1;
  grid-column-end: 12;
  justify-content: center;
  padding: 56px 0;
  background: ${({ theme }) => theme.base.white};
`;

export default LoadingWrapper;
